// extracted by mini-css-extract-plugin
module.exports = {"primary":"Primary_primary__1BONT"};